// Import and register all your controllers manually
import { application } from "./application"

// Import individual controllers
import ReviewFormController from "./review_form_controller"
import SampleController from "./sample_controller"
import ChartController from "./chart_controller"
import RadarChartController from "./radar_chart_controller"
import DelayedRedirectController from "./delayed_redirect_controller"

application.register("review-form", ReviewFormController)
application.register("sample", SampleController)
application.register("chart", ChartController)
application.register("radar-chart", RadarChartController)
application.register("delayed-redirect", DelayedRedirectController)
